import { render } from "./categorie_create.vue?vue&type=template&id=35806320"
import script from "./categorie_create.vue?vue&type=script&lang=js"
export * from "./categorie_create.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__